import { formatDateParam, makeRequest } from "../lib/makeRequest";
import moment from "moment";

export const inventory_details_overall_v4 = (data) =>
  makeRequest("/inventory-details/overall", {
    coveredDate: formatDateParam(data.covered_date),
  });

export const inventory_details_cluster_v4 = (data) =>
  makeRequest(`/inventory-details/cluster/${data.clusterId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const inventory_details_area_v4 = (data) =>
  makeRequest(`/inventory-details/area/${data.area_code}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const inventory_details_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append(
    "coveredDate",
    moment(data.covered_date).format("YYYY-MM-DD")
  );
  return makeRequest(
    `/inventory-details/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
